import { Link } from 'react-router-dom';
import { useCreateQuery } from '../../backend/hooks';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WhatsAppButton from '../../common/whatsapp';
import aboutImg from '../../assets/images/5.jpeg';

export default function About() {
    return (
       
        <main className="pt-24"> 
        <WhatsAppButton />
            {/* Hero Section */}
            <section className="w-full bg-[#15415c] py-16 md:py-20">
                <div className="max-w-4xl mx-auto px-6 text-center">
                    <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight leading-tight">
                        Innovative Therapy &amp; Medical Training Solutions
                    </h1>
                    <p className="mt-4 text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
                        Kinetix is a manufacturing-based company focused on producing functional, durable, and user-friendly therapy and medical simulation products. We combine practical design with quality craftsmanship to create equipment that improves therapy sessions, rehabilitation exercises, and medical training experiences.
                    </p>
                </div>
            </section>

            {/* Our Story */}
            <section className="py-16 md:py-24 bg-surface">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                        <div className="lg:col-span-7">
                            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-container text-on-secondary-container text-xs font-bold tracking-widest uppercase mb-6">
                                Our Story
                            </span>
                            <h2 className="text-4xl md:text-5xl font-extrabold font-headline tracking-tight text-on-surface mb-6 leading-[1.1]">
                                Built for Real‑World Therapy
                            </h2>
                            <p className="text-lg text-on-surface-variant max-w-xl leading-relaxed mb-8">
                                Whether you need ready-made products or custom-built solutions, our team works closely with therapists, healthcare professionals, educational institutes, and distributors to manufacture products that meet real-world needs.
                            </p>
                            <div className="flex flex-wrap gap-4">
                                <Link
                                    to="/Categories"
                                    className="px-8 py-4 bg-primary text-on-primary rounded-xl font-bold shadow-xl shadow-primary/20 hover:scale-105 transition-transform active:opacity-80"
                                >
                                    Our Products
                                </Link>
                            </div>
                        </div>
                        <div className="lg:col-span-5 relative">
                            <div className="rounded-3xl overflow-hidden shadow-2xl rotate-0">
                                <img
                                    alt="Kinetix Facility"
                                    className="w-full h-[500px] object-cover"
                                    src={aboutImg}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ✨ NEW: Got a Product Idea? Section – bg #173f59 */}
            <section className="w-full bg-[#173f59] py-12 md:py-16 my-12">
                <div className="max-w-3xl mx-auto px-6 text-center">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">
                        Got a Product Idea?
                    </h2>
                    <p className="mt-4 text-lg text-white/80 max-w-2xl mx-auto">
                        Have a custom therapy or rehabilitation product in mind? Share your idea with our team, and we'll help bring it to life.
                    </p>
                    <div className="mt-8 flex justify-center">
                        <a
                            href="https://wa.me/923144201005"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-3 px-8 py-4 bg-[#25D366] text-white font-bold rounded-xl shadow-lg hover:scale-105 transition-transform active:opacity-80"
                        >
                            <span className="material-symbols-outlined text-2xl">chat</span>
                            Chat on WhatsApp
                        </a>
                    </div>
                </div>
            </section>

            {/* Core Principles */}
            <section className="py-24 bg-surface-container-low">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="mb-16">
                        <h2 className="text-3xl font-extrabold font-headline text-on-surface tracking-tight mb-4">Core Principles</h2>
                        <div className="h-1.5 w-24 bg-primary rounded-full"></div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div className="bg-surface-container-lowest p-8 rounded-3xl transition-shadow hover:shadow-lg">
                            <span className="material-symbols-outlined text-primary text-4xl mb-6">verified</span>
                            <h3 className="text-2xl font-bold font-headline mb-4">Quality First</h3>
                            <p className="text-on-surface-variant leading-relaxed">
                                We are committed to delivering durable, reliable, and professionally tested therapy and rehabilitation equipment that ensures safety and long-term performance in every care environment.
                            </p>
                        </div>
                        <div className="bg-surface-container-lowest p-8 rounded-3xl transition-shadow hover:shadow-lg">
                            <span className="material-symbols-outlined text-primary text-4xl mb-6">lightbulb</span>
                            <h3 className="text-2xl font-bold font-headline mb-4">Innovation in Care</h3>
                            <p className="text-on-surface-variant leading-relaxed">
                                We focus on modern and smart solutions that enhance physiotherapy, occupational therapy, sensory integration, and home care experiences for better outcomes.
                            </p>
                        </div>
                        <div className="bg-surface-container-lowest p-8 rounded-3xl transition-shadow hover:shadow-lg">
                            <span className="material-symbols-outlined text-primary text-4xl mb-6">favorite</span>
                            <h3 className="text-2xl font-bold font-headline mb-4">Patient-Centered Approach</h3>
                            <p className="text-on-surface-variant leading-relaxed">
                                Every product is designed with the needs of patients, children, therapists, and caregivers in mind to support comfort, recovery, and independence.
                            </p>
                        </div>
                        <div className="bg-surface-container-lowest p-8 rounded-3xl transition-shadow hover:shadow-lg">
                            <span className="material-symbols-outlined text-primary text-4xl mb-6">handshake</span>
                            <h3 className="text-2xl font-bold font-headline mb-4">Trust & Reliability</h3>
                            <p className="text-on-surface-variant leading-relaxed">
                                We build long-term trust with healthcare professionals, schools, and families by providing consistent quality, dependable service, and proven therapy solutions.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}